import { EventEmitter, Type } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AssessmentMode, IInterviewHandler, IInterviewSettings, InterviewContextEvents, InterviewEventType, IVariable, IVariableEvaluationModel } from 'src/app/shared/interview-new/models/interview-handler.models';
import { VariableStringParserService } from './evaluation-formatters/variable-string-parser.service';
import { BaseVariableControl, IVariableControl } from './variable-controls/_base-control';
export abstract class AbstractInterviewHandler implements IInterviewHandler {

    get isPrimary() {
        return this.settings.mode === AssessmentMode.Primary;
    }

    events: InterviewContextEvents = new InterviewContextEvents(this);
    initialized: boolean;
    settings: IInterviewSettings;
    variableStringParserService: VariableStringParserService;
    onValueChanged: EventEmitter<BaseVariableControl>;
    onButtonClick: EventEmitter<IVariable>;
    fmBuilder: UntypedFormBuilder;
    form: UntypedFormGroup = new UntypedFormGroup({});
    controlMapping: { [key: string]: Type<IVariableControl>; };
    completed: boolean;
    processingFinalization: boolean;
    showErrorsAllowed: boolean = false;

    async initialize(settings: IInterviewSettings): Promise<void> {
        throw new Error('Method not implemented.');
    }
    evaluate(action: InterviewEventType, variables?: IVariableEvaluationModel[]) {
        throw new Error('Method not implemented.');
    }
    toggleSeverityMode() {
        throw new Error('Method not implemented.');
    }
    clear() {
        throw new Error('Method not implemented.');
    }
    prepareVariablesToEvaluate(): IVariableEvaluationModel[] {
        throw new Error('Method not implemented.');
    }

    protected abstract evaluateInternal(action: InterviewEventType, targetPage?: number, variables?: IVariableEvaluationModel[]): Promise<any>;

    //#region Navigation

    async postback() {
        await this.evaluateInternal(InterviewEventType.Postback);
    }

    async previous() {
        await this.evaluateInternal(InterviewEventType.Previous);
    }

    async next() {
        await this.evaluateInternal(InterviewEventType.Next);
    }

    async forward() {
        await this.evaluateInternal(InterviewEventType.Forward);
    }

    async toPage(pageIndex: number) {
        await this.evaluateInternal(InterviewEventType.Goto, pageIndex);
    }

    finish(): any {

    }
    finalizev2(extraContextData?: any): Promise<any> {
        return Promise.resolve(null);
    }
    finalize(extraContextData?: any): Promise<any> {
        return Promise.resolve(null);
    }

    //#endregion


}
